import UnderConstructionPage from '../../underconstruction-page';
import {
  MonthySalaryStaffList,
  CreateMonthySalaryStaff,
  CreateMonthySalaryContractual,
  MonthySalaryContractualList,
  SalaryTiles,
  MonthySalaryOperatorList,
  CreateMonthySalaryOperator,
  AnnualLeavesList,
  CreateAnnalLeaves,
} from '../../pages/salaryManagement';

const salaryManagement = [
  {
    path: 'salarymanagement',
    element: <SalaryTiles />,
  },
  {
    path: 'monthlysalaryContractual',
    element: <UnderConstructionPage />,
  },
  {
    path: 'monthlysalaryOperator',
    element: <UnderConstructionPage />,
  },
  {
    path: 'monthlysalaryStaffList',
    element: <MonthySalaryStaffList />,
  },
  {
    path: 'createmonthysalaryStaff',
    element: <CreateMonthySalaryStaff />,
  },
  {
    path: 'monthlysalaryContractualList',
    element: <MonthySalaryContractualList />,
  },
  {
    path: 'createmonthysalaryContractual',
    element: <CreateMonthySalaryContractual />,
  },
  {
    path: 'monthysalaryoperatorList',
    element: <MonthySalaryOperatorList />,
  },
  {
    path: 'createmonthysalaryOperator',
    element: <CreateMonthySalaryOperator />,
  },
  {
    path: 'annualLeavesList',
    element: <AnnualLeavesList />,
  },
  {
    path: 'createAnnalLeaves',
    element: <CreateAnnalLeaves />,
  },
];

export { salaryManagement };
